import { defineStore } from "pinia";
import { ref, computed } from "vue";

export const useAllConditionsStore = defineStore("conditions", () => {
  const conditions = ref([
    { id: "Denunciante", nombre: "Denunciante" },
    { id: "Damnificado", nombre: "Damnificado" },
    { id: "victima", nombre: "Víctima" },
    { id: "Acusado", nombre: "Acusado" },
    { id: "Fallecido", nombre: "Fallecido" },
    { id: "Extraviado", nombre: "Extraviado" },
    { id: "Detenido", nombre: "Detenido" },
    { id: "Protagonista", nombre: "Protagonista" },
    { id: "Acompañante", nombre: "Acompañante" },
    { id: "Peatón", nombre: "Peatón" },
    { id: "Autolesionado", nombre: "Autolesionado" },
    { id: "Acusado y/o Detenido", nombre: "Acusado y/o Detenido" },
  ]);

  const getAll = () => conditions.value;

  const getByNombre = (nombre) => {
    if (!nombre) return null;

    const condition = conditions.value.find((n) => n.nombre.toUpperCase() === nombre.toUpperCase());

    return condition ? condition.id : null;
  };

  return {
    conditions,
    getAll,
    getByNombre,
  };
});
